import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function IncidentTrends() {
  const data = [
    { month: "Jan", critical: 12, high: 23, medium: 45, low: 18 },
    { month: "Feb", critical: 8, high: 19, medium: 52, low: 22 },
    { month: "Mar", critical: 15, high: 28, medium: 38, low: 25 },
    { month: "Apr", critical: 6, high: 21, medium: 43, low: 19 },
    { month: "May", critical: 11, high: 25, medium: 49, low: 21 },
    { month: "Jun", critical: 9, high: 18, medium: 41, low: 17 },
    { month: "Jul", critical: 14, high: 31, medium: 47, low: 23 },
    { month: "Aug", critical: 8, high: 15, medium: 32, low: 21 }
  ];

  return (
    <div className="chart-card">
      <div className="chart-card__header">
        <h3 className="chart-card__title">Incident Trends</h3>
        <p className="chart-card__subtitle">Monthly incident breakdown by severity</p>
      </div>
      <div className="chart-card__content">
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={data}>
            <defs>
              <linearGradient id="criticalGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#EF4444" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#EF4444" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="highGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#F97316" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#F97316" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="mediumGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#EAB308" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#EAB308" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="lowGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#3B82F6" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="month" stroke="#6b7280" fontSize={12} />
            <YAxis stroke="#6b7280" fontSize={12} />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'white', 
                border: 'none', 
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', 
                borderRadius: '8px' 
              }} 
            />
            <Legend />
            <Area type="monotone" dataKey="critical" stackId="1" stroke="#EF4444" fill="url(#criticalGradient)" name="Critical" />
            <Area type="monotone" dataKey="high" stackId="1" stroke="#F97316" fill="url(#highGradient)" name="High" />
            <Area type="monotone" dataKey="medium" stackId="1" stroke="#EAB308" fill="url(#mediumGradient)" name="Medium" />
            <Area type="monotone" dataKey="low" stackId="1" stroke="#3B82F6" fill="url(#lowGradient)" name="Low" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
